import React from "react";
import AdminDashboard from "./Admin/AdminDashboard";
import CustomerDashboard from "./Customer/CustomerDashboard";
import { checkIsAdmin } from "../helpers/helpers";

// Single /dashboard landing path for both admin and customer logins.
const DashboardRouter = () => (checkIsAdmin() ? <AdminDashboard /> : <CustomerDashboard />);

export default DashboardRouter;
